<template>
  <header class="header">
    <div class="inner-header">
      <nav>
        <router-link to="/">
          <nav class="logo-box">
            <Logo /> <span>젊은이부</span>
          </nav>
        </router-link>
      </nav>
      <ul class="nav-categories pc">
        <li v-for="(navItem, navIdx) in navList" v-bind:key="navIdx">
          <router-link :to="navItem.to" class="underline-animation">{{ navItem.name }}</router-link>
        </li>
      </ul>
      <ul class="nav-categories mobile">
        <li @click="openMenuModal">
          <i class="bi bi-list" />
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
  import Logo from "@/components/common/logo/Logo.vue";

  export default {
    name: "Header",
    components: {Logo},
    props: {
      currentNav: {
        type: String,
        default: 'Home'
      },
      openMenuModal: {
        type: Function,
      }
    },
    data() {
      return {
        navList: [
          {
            'name': '젊은이부 소개',
            'to': '/about'
          },
          {
            'name': '갤러리',
            'to': '/gallery'
          },
        ],
      }
    },
    mounted() {
    }
  }
</script>

<style scoped lang="scss">
  .header {
    z-index: 99;
    border-bottom: 1px solid rgba(255, 255, 255, .2);
    background-color: #fff;

    .inner-header {

      max-width: 1280px;
      width: 100%;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 25px 10px;
      text-align: left;

      display: flex;
      justify-content: space-between;
      align-items: center;

      nav {

        display: flex;
        align-items: center;

        a {
          color: #333;
          font-weight: 700;
          font-size: 20px;
          line-height: 0.9;

          span {
            font-weight: 500;
            color: #333;
            font-size: 17px;
            //margin-top: 10px;
            margin-left: 10px;
            display: inline-block;
          }
        }
      }

      .nav-categories {

        display: flex;

        &.pc {
          display: flex;
        }

        &.mobile {
          display: none;
        }

        li {

          box-sizing: border-box;
          padding: 10px;

          &:last-child {
            padding-right: 0;
          }

          a {
            font-size: 16px;
            font-weight: 700;
            color: #555;
            transition: color 0.3s ease; /* 색상 변화에 트랜지션 적용 */


            &:hover {
              //color: #00c5e3;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1512px) {
    .header {

      .inner-header {
        padding: 25px;
      }

    }
  }

  @media screen and (max-width: 768px) {

    ::v-deep(svg) {
      height: 36px;
    }

    .header .inner-header nav a span {
      font-size: 16px;
    }

    .header .inner-header .nav-categories.pc {
      display: none;
    }

    .header .inner-header .nav-categories.mobile {
      display: flex;
    }

    .header .inner-header .nav-categories.mobile i {
      font-size: 24px;
      cursor: pointer;
    }
  }


</style>